//@ts-nocheck
import { AdminTemplate, InputControl, SectorMappingInstallmentMappingManagementForm } from '../../components';
import React, { useEffect, useState } from 'react';

export const SectorInstallmentMappingManagement = () => {

    const [currentSector, setCurrentSector] = useState(null as any);

    return <>
        <AdminTemplate
            headerProps={{ headerTitle: "Sektör Taksit Kıstlaması", hideAddButton: true }}
        >
            <SectorMappingInstallmentMappingManagementForm />
        </AdminTemplate>
    </>;
};